"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _AddOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/action/AddOutline"));

// Generated by script, don't edit it please.
var AddOutline = (0, _createSvgIcon["default"])({
  as: _AddOutline["default"],
  ariaLabel: 'add outline',
  category: 'action',
  displayName: 'AddOutline'
});
var _default = AddOutline;
exports["default"] = _default;
module.exports = exports.default;